module.exports = __webpack_public_path__ + "static/img/Enari-Tuala.0997d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Enari-Tuala.jpg
// module id = qVMK
// module chunks = 0